import React, { forwardRef, useRef } from 'react';

import { ContentBlocksRenderer } from '../../../ContentZone/student/ContentBlocksRenderer';
import { useContentRequirementsContext } from '../../../features/RestrictNavigation/ContentRequirementsProvider';
import { ContentWrapper } from '../../ContentWrapper/ContentWrapper';
import { ProgressBar } from '../../ProgressBar/ProgressBar';
import { FullScreenContentModalNavigation } from './FullScreenContentModalNavigation';
import { Question, StartingMessage } from '@ael/core-api';
import { FroalaEditorsSettings } from "../../../../config/configs";

export interface FullScreenContentModalProps {
  contentItem: StartingMessage | Question;
  onContinue: () => void;
  froalaEditorsSettings: FroalaEditorsSettings;
}

export const FullScreenContentModal = forwardRef(
  ({ contentItem, onContinue, froalaEditorsSettings }: FullScreenContentModalProps, ref: React.Ref<HTMLDivElement>) => {
    const requirements = useContentRequirementsContext();

    const { id, content, title } = contentItem;
    const toolbarRef = useRef(null);

    return (
      <ContentWrapper>
        <ContentWrapper.Modal ref={ref}>
          {id && (
            <ContentWrapper.TopBar>
              <ProgressBar
                steps={[
                  {
                    id,
                    selected: true,
                    disabled: false,
                  },
                ]}
              />
            </ContentWrapper.TopBar>
          )}
          <ContentWrapper.DesktopContent>
            <ContentWrapper.Title title={title} />
            <ContentWrapper.Body noHorizontalPadding>
              <ContentBlocksRenderer contentItem={contentItem} content={content} inSmallWindow={false} froalaEditorsSettings={froalaEditorsSettings} />
            </ContentWrapper.Body>
          </ContentWrapper.DesktopContent>
          <ContentWrapper.Toolbar ref={toolbarRef}>
            <FullScreenContentModalNavigation
              ref={toolbarRef}
              goToNext={onContinue}
              contentItem={contentItem}
              progressDisabled={!requirements.fulfilled}
            />
          </ContentWrapper.Toolbar>
        </ContentWrapper.Modal>
        <ContentWrapper.Caption />
      </ContentWrapper>
    );
  }
);
